import { render, staticRenderFns } from "./Coverage.vue?vue&type=template&id=447a1143"
import script from "./Coverage.vue?vue&type=script&lang=js"
export * from "./Coverage.vue?vue&type=script&lang=js"
import style0 from "./Coverage.vue?vue&type=style&index=0&id=447a1143&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports